var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandesgartenschau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 188,
    viewBox: "0 0 170 188",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 188,
    fill: "rgba(0,0,0,0.01)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.516 2423.07c15.675 19.85 39.847 19.45 55.07-1.68l70.062-97.21 55.68-77.27v523.98H.004v-545.44l140.512 197.62",
    style: {
      fill: "#bfdf14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 369.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768.613 2268.95 367.187 501.94H714.063l-212.45-305.92 104.614-27.38c26.054-6.81 34.914-30.4 19.796-52.68l-152.035-224.16 261.649 109.17c12.433 5.19 24.125 4.44 32.976-.97",
    style: {
      fill: "#81bc29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 369.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2188.55v-214.74c3.754 8.08 11.09 14.83 22.027 18.61v.01l242.645 83.09S0 2177.95 0 2188.55",
    style: {
      fill: "#ed1181",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 369.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1947.76v-589.37h321.324v532.76l-106.636-150.2c-15.59-21.95-41.481-22.41-57.833-1.02L4.535 1939.64A45.131 45.131 0 0 0 0 1947.76",
    style: {
      fill: "#80d5e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 369.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.672 1716.82a749036.608 749036.608 0 0 0 269.031-358.43h457.447c-163.38 199.43-322.447 390.67-477.283 573.89-6.601-5.83-17.933-9.13-29.336-5.68l-272.086 81.38 28.305-32.37 141.852-162.29c17.714-20.27 11.808-44.79-13.204-54.76l-104.726-41.74",
    style: {
      fill: "#318ed5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 369.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.422 2034.27h82.523v82.52h-82.523v-82.52",
    style: {
      fill: "#ed1181",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 369.453)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandesgartenschau);
export default __webpack_public_path__ + "static/media/landesgartenschau.c5ae487bd792884dc03a91bdb056f1eb.svg";
export { ForwardRef as ReactComponent };